export default {
  ja: {
    Home: {
      title: "在庫金額アプリ",
      whatIs: "在庫金額アプリとは",
      thisIs: "在庫金額（入庫単価×数量）を表示・CSVダウンロードできるアプリです。",
      account: "アカウント",
      companyName: "会社名",
      userName: "ユーザ名",
      planName: "プラン名",
      changeAccount: "アカウントを変更したい場合は、zaicoから一度ログアウトしてから、この画面を開き直して下さい。",
      usage: "使い方",
      makeSurePlan: "ライトプラン以上のご契約が必要です。",
      selectPeriod: "在庫金額を計算したい期間を選択する",
      selectDay: "在庫金額を計算したい日付を選択する",
      period: "期間",
      aLotOfInventory: "期間が長い場合、数分かかる可能性があります。",
      inBackground:
        "集計はバックグラウンドで実行されるので、集計完了を待つ間に他の画面に遷移し、後でこの画面に戻ってきても構いません。",
      tally: "集計",
      totalNumber: "全データ数",
      receive: "入庫",
      shippingOut: "出庫",
      totalAmount: "の合計在庫金額",
      closeTallyResults: "プレビューを閉じる",
      viewTallyResults: "プレビューを見る",
      upTo1000: "プレビューは、最大1,000件まで表示されます。",
      CSVDownload: "CSVダウンロード",
      correctPeriodad: "正しい期間を指定してください。",
      Increase_or_decrease_in_the_amount_of_inventory_during_the_period: "期間中の入出庫金額",
      Amount_of_inventory_on_the_specified_date: "指定日の在庫金額",
      oneday_day: "指定日：",
      oneday_last_price: "最終仕入原価法",
      oneday_fifo: "先入先出法",
      oneday_moving_average_method: "移動平均法",
      hasNoPriceData1: "警告！",
      hasNoPriceData2: "在庫金額が計算できないデータがありました！（背景がピンク色の行）",
      hasNoPriceData6: "プレビューの行をクリックするとzaicoの変更履歴画面が開きます",
      hasNoPriceData3: "【原因】",
      hasNoPriceData4: "入庫データが存在しない",
      hasNoPriceData5: "入庫データは存在するが、仕入単価が未入力",
      hasNoPriceData7: "入出庫データに紐づく変更履歴が存在しない",
      help_ja_1: "内容について不明点がある場合、",
      help_ja_2: "ヘルプページ",
      help_ja_3: "をご確認ください。",
      detailed_data: "詳細データ（同じ物品でも仕入単価が異なる場合は別の行）",
      aggregate_data: "物品集計データ（仕入単価が異なっていても同じ物品なら同じ行）",
      advanced_plan_warning_detail_1: "・結果は最大5件に制限されます。",
      advanced_plan_warning_detail_2: "・全件表示するにはproプラン以上のご契約が必要です。",
      only_purchase_and_packing_slip: "入出庫データがない変更履歴は計算対象外にする",
      is_use_inventory_unit_price: "入庫データの仕入単価がない場合は在庫データの仕入単価で計算する",
      sort_type_option: "※入出庫日が同じ場合",
      purchase_first: "「入庫」を先として扱う",
      delivery_first: "「出庫」を先として扱う",
      amount: "在庫金額",
      totalQuantity: "合計数量",
      asOfSpecifiedDate: "{date} 時点",
    }
  }
};
